import React, { useState } from 'react';
import { FilterBar, TableData } from "components";
import { setErrorCodesHistoryProvider } from 'redux/slices/admin/providerSlice';
import { getProviderCredsErrorCodesHistoryService } from 'services/admin/providerService';
import { useDispatch, useSelector } from 'react-redux';
import { errorAlert } from 'helpers/alerts';
import moment from 'moment';
import { CompareArrows } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

function HomologacionPendientesScreen() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { hebeErrorCodesHistoryList } = useSelector(store => store.providers)
  const [loading, setLoading] = useState(false)
  const [filters, setFilters] = useState(null)

  return (
    <>
      <FilterBar
        handlerFilter={async (data) => {
          setLoading(true)
          data.state = false
          setFilters(data)
          getProviderCredsErrorCodesHistoryService('all', data)
            .then(response => dispatch(setErrorCodesHistoryProvider(response)))
            .catch(error => errorAlert(error))
            .finally(() => setLoading(false))
        }}
        defaultValues={{
          date: [moment().subtract(30, 'days').toDate(), new Date()],
        }}
        allValue={null}
        filters={[
          {
            type: "dates",
            name: "date",
            label: "Fecha",
          },
        ]}
      />
      <TableData
        dataRows={hebeErrorCodesHistoryList}
        loading={loading}
        dataTitle={[
          "Proveedor",
          "Codigo de Error",
          "Mensaje",
          "Cantidad de ocurrencias",
        ]}
        formatter={({ provider, code, message, count }) => ([
          provider,
          code,
          message,
          count
        ])}
        actions={[
          {
            label: "Transacciones",
            icon: <CompareArrows />,
            onClick: (data) => {
              navigate('/reportes/detallado', {
                state: {
                  state: 2,
                  code: data.code,
                  date: filters.date,
                  provider: data.provider,
                }
              });
            },
          },

        ]}
      />
    </>
  );
}


export default HomologacionPendientesScreen;